angular
  .module('contributor')

  .factory('UnitCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class UnitCrud extends Crud {
        constructor(list) {
          super(
            'unit' + (list || ''),
            '@@apiUrl' + '/units' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return UnitCrud;
    }
  ]);
